const en = {
    next: 'Next',
    error: 'Error',
    notFound: '404 Not found.',
    m: {
        loginTitle: "Unlock Your Power Bank",
        phonePlaceholder: "Mobile number",
        or: 'or',
        emailLogin: 'Continue with Email',
        phoneLogin: 'Continue with Phone',
        quickLogin: 'Continue as Guest',
        loginRequiredTip: 'Please log in first',
        continueGoogle: "Continue with Google",
        continueApple: "Continue with Apple",
        langBoxTitle: "Choose a language",
        policyAndTerms: "Agree to [brandName]'s <a href='[termsOfServiceUrl]'>Terms of Service</a> and <a href='[privacyPolicyUrl]'>Privacy Policy</a>.",
        verifyTitle: 'Enter the 6-digit code sent to you at [phonenumber]',
        verifyEmailTitle: 'Enter the 6-digit code sent to you at [email]',
        paymentTitle: 'Unlock your power bank',
        resend: "Resend Code",
        emailAddress: "Email address",
        registerTitle: 'Enter your information.',
        fNameInput: 'First Name',
        lNameInput: 'Last Name',
        emailInput: 'Email Address',
        birthInput: 'Date of Birth',
        postCodeInput: 'Post Code',
        billingRate: 'Rate',
        unpaidPopupSubtitle: 'You have unpaid order',
        unpaidPopupContent: 'You have an unpaid order. Please settle the payment before renting again.',
        payNow: 'Pay Now',
        add: 'Add',
        minBalanceTag: 'Min: {amount}',
        paymentSuccessfulSubtitle: 'Payment Successful!',
        paymentSuccessfulContent: 'You can continue with your rental now!',
        goToRental: 'Go to Rental',
        repaymentTitle: 'Order Payment',
        rentalInformation: 'Rental Information',
        selectPayMethod: 'Select Payment Method',
        selectAuthorizationMethod: 'Select Authorization Method',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: 'Balance',
        creditOrDebit: 'Credit or Debit Card',
        free: 'Free',
        pay: 'Pay',
        confirm: 'Confirm',
        cancel: 'Cancel',
        unlockNow: 'Unlock Power Bank',
        savePay: 'Confirm & Pay',
        saveRent: 'Rent',
        recharge: 'Top up',
        balancePopupTitle: 'Top Up',
        balancePopupCurrentBalance: 'Current balance: {amount}',
        balancePopupMinRentBalance: 'Minimum balance to rent: {amount}',
        topUpRent: 'Top Up',
        topUpSaveCard: 'Top up',
        bindPopupTitle: 'Add payment card',
        cardPaymentTitle: 'Card payment',
        preparingTitle: 'Preparing your charger',
        preparingSubtitle: 'Your power bank is being ejected. Please wait patiently.',
        preparingStationBusySubtitle: 'Waiting for the previous power bank to finish ejecting. Please wait.',
        rentalSuccessTitle: 'Success!',
        rentalFailTitle: 'Fail!',
        rentalSuccessSubtitle: 'Thank you for using [brandName]. Please return the power bank after use.',
        rentalNumber: 'Order Number',
        rentalTime: 'Rental Time',
        rentalLocation: 'Rental Location',
        returnTime: "Return Time",
        returnLocation: "Return Location",
        rentalDuration: "Rental Duration",
        totalAmount: "Total Amount",
        paidAmount: "Paid Amount",
        unpaidAmount: "Amount Due",
        currentFee: "Estimated fee",
        rentalInfo: 'Rental Information',
        rentingTitle: 'You are currently using a [brandName] power bank',
        keepIt: 'Want to keep it? Buy now!',
        findNearby: 'Find nearby return stations easily—download our app now!',
        nearbyStationTitle: 'Nearby Station',
        nearbyStationSearchPlaceholder: 'Search for nearby charging stations',
        nearbyStationRent: 'Rent',
        nearbyStationReturn: 'Return',
        nearbyStationAvailable: 'Available',
        nearbyStationEmpty: 'Empty',
        nearbyStationLoading: 'Loading nearby stations...',
        nearbyStationNoStations: 'No nearby stations',
        nearbyStationNoRentStations: 'No nearby rentable stations',
        nearbyStationNoReturnStations: 'No nearby returnable stations',
        nearbyStationSearchAria: 'Search nearby stations',
        nearbyStationType: 'Station type',
        nearbyStationDistance: 'Distance',
        scanForPowerbank: 'Scan for Powerbank',
        scanOtherMachine: 'Scan other machine',
        findNearbyReturnableMachines: 'Find Return Machines',
        scannedMachine: 'Scanned machine',
        scannedMachineWithCode: 'Scanned machine {code}',
        loginViewNearbyRentableMachines: 'View Nearby Machines',
        viewNearbyReturnLocations: 'Find Return Machines',
        currentMachineUnavailableHint: 'This machine is not available',
        currentMachineAvailableHint: 'Current machine is ready',
        currentMachineMapDetail: 'You scanned machine {code}. Tap here to return and continue renting from this machine.',
        currentMachineMapAction: 'Tap to continue renting from this machine.',
        machineUnavailableMapDetail: 'You scanned machine {code}, but it cannot be used now. Reason: {reason}. Please scan another machine or use nearby stations on the map.',
        machineUnavailableMapAction: 'Find a nearby available machine and scan its code.',
        mapIslandMachineUnavailableShort: 'This machine is not available',
        mapIslandMachineAvailableActionShort: 'Continue on this machine',
        mapIslandMachineUnavailableActionShort: 'Scan another nearby machine',
        mapIslandReturnActionShort: 'Back to rental',
        rentingMapIslandTitle: 'Rental in progress',
        tapToReturnRentalPage: 'Tap to return to rental.',
        scan: 'Scan',
        scannerHint: 'Find QR code on charging station',
        flashlight: 'Flashlight',
        mapBack: 'Back',
        currentLocation: 'Current location',
        backToMap: 'Back to map',
        mapMenu: 'Menu',
        mapMenuYourInfo: 'Your Info',
        mapMenuLanguage: 'Language',
        mapMenuHelp: 'Help',
        helpTitle: 'Help',
        helpReportProblem: 'Report a Problem',
        helpChatWithUs: 'Chat with us',
        chatWithUsTitle: 'Chat with Us',
        chatContactMethods: 'Contact methods',
        reportProblemTitle: 'Report a Problem',
        reportDeviceCode: 'Device code',
        reportScanQrCode: 'Scan machine QR code',
        reportDeviceCodePlaceholder: 'Scan machine QR or enter Device ID',
        reportProblemType: 'Problem',
        reportProblemTypeAria: 'Problem type',
        reportProblemPowerBankNotEjected: 'Power bank not ejected',
        reportProblemCannotChargeDevice: 'Cannot charge device',
        reportProblemOrderNotEnded: 'Order not ended',
        reportProblemCableDamagedLost: 'Cable damaged/lost',
        reportProblemOther: 'Other',
        reportTakePicture: 'Upload image',
        reportChooseOrTakePicture: 'Upload image',
        reportRemovePicture: 'Remove picture',
        reportDescribeProblem: 'Describe the problem',
        reportDescriptionPlaceholder: 'Please enter a description',
        reportFieldRequired: 'Required',
        reportFieldOptional: 'Optional',
        reportSubmit: 'Submit',
        reportSubmittedSuccessfully: 'Submitted successfully',
        mapMenuLogin: 'Log in',
        mapMenuLogout: 'Log out',
        mapMenuLogoutSuccess: 'Logged out',
        mapMenuLoadingProfile: 'Loading profile...',
        mapMenuLogoutConfirmTitle: 'Log out?',
        mapMenuLogoutConfirmContent: 'You will need to log in again before renting.',
        profileTitle: 'Profile',
        profileSave: 'Save',
        profileNoChanges: 'Please update at least one field with a value.',
        profileDeleteAccount: 'Delete',
        profileDeleteConfirmTitle: 'Delete Account?',
        profileDeleteConfirmContent: 'All data in your account will be permanently deleted, and you will be logged out after deletion.',
        closeScanner: 'Close scanner',
        directions: 'Directions',
        call: 'Call',
        cabinet: 'Cabinet',
        addressUnavailable: 'Address unavailable',
        open: 'Open',
        closed: 'Closed',
        opens: 'Opens',
        closes: 'Closes',
        hoursUnavailable: 'Hours unavailable',
        mapUnavailable: 'Map unavailable',
        googleMapsKeyNotConfigured: 'Google Maps key is not configured',
        googleMapsLoadFailed: 'Google Maps failed to load',
        retry: 'Retry',
        mapLoading: 'Loading map...',
        mapReloading: 'Reloading map...',
        cameraUnavailable: 'Camera is not available in this browser',
        cameraPermissionDenied: 'Camera permission was denied',
        cameraStartFailed: 'Camera failed to start',
        flashlightUnsupported: 'Flashlight is not supported on this device',
        flashlightSwitchFailed: 'Flashlight failed to switch',
        invalidQrCode: 'Invalid QR code format',
        noon: 'Noon',
        weekdayMonday: 'Monday',
        weekdayTuesday: 'Tuesday',
        weekdayWednesday: 'Wednesday',
        weekdayThursday: 'Thursday',
        weekdayFriday: 'Friday',
        weekdaySaturday: 'Saturday',
        weekdaySunday: 'Sunday',
        weekdayMon: 'Mon',
        weekdayTue: 'Tue',
        weekdayWed: 'Wed',
        weekdayThu: 'Thu',
        weekdayFri: 'Fri',
        weekdaySat: 'Sat',
        weekdaySun: 'Sun',
        orderDeatil: 'Order Details',

        subsTitle: 'Select Plan',
        default: 'Default',
        subscribeAndSave: 'Subscribe & Save',
        autoRenew: 'Automatic Renewal',
        reachLimit: 'Usage Limit Reached',
        paymentAuthorizationTitle: 'Payment Authorization',
        paymentAuthorizationRequired: 'Payment authorization required',
        paymentAuthorizationDesc1: '',
        paymentAuthorizationDesc2: 'Authorization is required if the rental may exceed your plan or if no payment method is linked for potential extra charges.',
        paymentAuthorizationDesc3: 'A temporary hold of [amount] will be placed. It will be fully released after return if no extra charges apply; otherwise, the remaining balance will be refunded after deducting any additional charges.',
        paymentAuthorizationDesc4: 'Please select one of the authorization methods below for this rental.',

        totalCost: 'Total Cost',
        returnSuccessTitle: 'Return Successfully!',
        returnSuccessSubtitle: 'Thank you for using [brandName].',
        rentAgain: 'Rent Again',
        guestLoginTips: 'This feature requires a formal account. Guest mode is not available. Would you like to log in?',
        stationNotFoundTitle: "Station Not Found",
        stationNotFound: "Please try scanning the code again.",
        stationNotSetUpTitle: "Station Not Set Up",
        stationNotSetUp: "Please contact the administrator for assistance, or check other nearby stations.",
        stationOfflineTitle: "Station Offline",
        stationOffline: "Please check if the power cable is properly connected, or try unplugging and re-plugging it.",
        stationBusyTitle: "Station Busy",
        stationBusy: "The station is currently processing the rental task. Please wait a moment and try again.",
        powerBanksUnavailableTitle: "Power Banks Unavailable",
        powerBanksUnavailable: "Power banks are temporarily unavailable due to a technical issue. Please try again later or check another nearby station.",
        noPowerBanksAvailableTitle: "No Power Banks Available",
        noPowerBanksAvailable: "Please check another nearby station.",
        serverErrorTitle: "Server Error",
        serverError: "Please try again later, or contact the administrator for assistance.",
    },
    tMsg: {
        agreePolicy: 'Agree to [brandName]‘s Privacy Poilicy and Terms & Conditions',
        errorTel: 'Please enter correct phone number',
        sendSuccess: 'Sent successfully',
        inputAll: 'Please enter all required information',
        wrongEmail: 'Incorrect email format',
        wrongBirthday: 'Please enter the correct Date of Birth format',
        initPayFail: 'Init payment failed',
        bindTimeout: 'Bind card timeout, please try again',
        bindSuccess: 'Bind card success',
        subscriptionSuccess: 'Subscription purchased successfully',
        bindFailed: 'Bind card failed',
        paymentFailed: 'Payment failed',
        loginError: 'Login error',
        paymentMethodNotSupported: 'Payment method not supported',
    },
    bRule: {
        priceDesc: '[price]',
        priceTimeDesc: '/[price_time] minutes',
        freeTimeDesc: 'Free [free_time] minutes',
        flatFeeDesc: '[flat_fee] flat fee for the first [flat_fee_time] minutes',
        lowLimitDesc: 'Minimum fee: [low_limit]',
        topLimitDesc: 'Maximum daily fee: [top_limit]',
        preAuthDesc: '[pre_auth_amount] will be pre-authorized on your payment method',
        depositDesc: 'If not returned within [maximum_rental_time] hours, you will be charged [deposit], and the power bank will belong to you',
        ruleError: 'Rule error',
        noneRuleDesc: 'No rules',
        taxIncluded: 'Tax included',
        taxIncludedWithRate: 'Includes [tax]% tax',
    },
    subscriptionType: {
        1: 'Free [value] minutes per subscription period',
        2: 'Free [value] minutes per month',
        3: 'Free [value] minutes per week',
        4: 'Free [value] minutes per day',
        6: 'Free [value] times per subscription period',
        7: 'Free [value] times per month',
        8: 'Free [value] times per week',
        9: 'Free [value] times per day',
        unlimited: 'unlimited',
        unlimitedRentals: 'Free unlimited rentals per subscription period',
        durationLimit: 'Up to [limit] minutes of free rental per rental. Then [price] per [price_time] minutes',
        maxLimit: ', max [top_limit] per day.',
    },
    subscriptionTitleType: {
        1: '[value] minutes per subscription period',
        2: '[value] minutes per month',
        3: '[value] minutes per week',
        4: '[value] minutes per day',
        6: '[value] times per subscription period',
        7: '[value] times per month',
        8: '[value] times per week',
        9: '[value] times per day',
        unlimited: 'Unlimited',
        unlimitedRentals: 'Unlimited rentals per subscription period',
    },
    subscriptionInfo: {
        period: 'From [start] to [end]',
        usedShort: '([used]/[total] used)',
        usage: 'Usage: [total] total, [used] used, [remaining] remaining',
        usageUnlimited: 'Usage: Unlimited',
        autoRenew: 'Automatic Renewal: [value]',
        autoRenewTrue: 'Yes',
        autoRenewFalse: 'No',
    },
    time: {
        day: 'day | days',
        hour: 'hour | hours',
        minute: 'minute | minutes',
        second: 'second | seconds',
        month: 'month | months',
        year: 'year | years',
    },
    eMsg: {
        30001: 'Human verification failed',
        500: "Network Error",
        1000: "Operation Failed",
        30022: "Please enter the correct phone number format",
        30128: "Verfication code sent too many times. Please try again later",
        30129: "Failed to send verification code",
        30101: 'Verification code is incorrect or expired',
        // 租借
        50101: "Station not found",
        50105: "You have an outstanding order",
        50106: "Station is currently offline",
        50108: "There are currently no available chargers",
        50109: "Failed to release charger. Please try again",
        50113: 'This station requires an account to use',
        50114: 'Guests can’t use this feature. Please log in',
        50111: 'Invalid payment method',
        50305: 'Invalid payment method',
        80411: 'bind card fail',
        50103: 'No valid payment method',
        50206: 'Your last order payment failed. Please update your payment method',
    }
}
export default en

/*
请先阅读并同意隐私协议和条款
请输入所有必填信息
30022 手机号格式不对
30128 获取验证码次数太多
30129 发送验证码失败
30101 验证码不对或已失效
不正确的生日格式
80411 绑定银行卡失败

50106 station offline
50108 机柜内没有可租借的充电宝
50109 弹出电池失败
 */
